<template>
    <div id="route-live" class="card card-small" v-if="liveState" style="margin-bottom:2rem">
      <div class="flex">
        <LiveTimer :liveState="liveState" v-if="liveState.started" />
        <div class="fill-x flex flex-sb">
          <template v-if="!liveState.started">
            Planlagt starttidspunkt
            <h2 style="margin:0">{{ route.settings.startTime }}</h2>
          </template>

          <template v-else-if="liveState.driving && liveState.next">
            <div>
              <div class="text-overline">Næste</div>
              <div class="text-B">{{liveState.next.name}}</div>
              <div class="text-small text-secondary">{{liveState.next.address}}</div>
            </div>
            <div class="text-r">
              <div class="text-overline">Ankomst</div>
              <h2>{{ $filters.time(liveState.next.times.arrival + liveState.timeOffset) }}</h2>
              <div class="text-small delay" :class="liveState.timeOffset > 0 ? 'color-error' : 'color-success'" v-tooltip="'Forsinkelse'">{{ liveState.timeOffset &lt; 0 ? '-' : '+' }}{{$filters.duration(liveState.timeOffset)}}</div>
            </div>
          </template>

          <template v-else-if="liveState.current">
            <div>
              <div class="text-overline">Nu</div>
              <div class="text-B">{{ liveState.current.name }}</div>
              <div class="text-small text-secondary">{{ liveState.current.address }}</div>
            </div>
            <div class="text-r">
              <div class="text-overline">Afgang</div>
              <h2>{{ $filters.time(liveState.current.times.departure + liveState.timeOffset) }}</h2>
              <div class="text-small delay" :class="liveState.timeOffset > 0 ? 'color-error' : 'color-success'" v-tooltip="'Forsinkelse'">{{ liveState.timeOffset &lt; 0 ? '-' : '+' }}{{$filters.duration(liveState.timeOffset)}}</div>
            </div>
          </template>
        </div>
      </div>

      <div v-if="liveState.started && !liveState.driving && liveState.next">
        <div class="divider"></div>
        <div class="text-overline">Næste</div>
        <div class="text-B">{{ liveState.next.name }}</div>
        <div class="text-small text-secondary">{{ liveState.next.address }}</div>
      </div>

      <div v-if="!liveState.started">
        <div class="divider"></div>
        <div class="text-overline">Nuværende</div>
        <div class="text-B">{{ liveState.current.name }}</div>
        <div class="text-small text-secondary">{{ liveState.current.address }}</div>
      </div>

      <LiveControls v-if="controls" :route="route" :liveState="liveState" style="margin-top:1rem"/>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { store } from '@/store'
import LiveTimer from '@/components/live/LiveTimer.vue'
import LiveControls from '@/components/live/LiveControls.vue'
import { Route, RouteLiveState } from '@/api/tripply/models'

export default defineComponent({
  name: 'LivePanel',
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    liveState: {
      type: Object as PropType<RouteLiveState>,
      required: true
    },
    controls: Boolean
  },
  components: { LiveTimer, LiveControls },
  setup(props) {

    return { store }
  }
})
</script>

<style scoped lang='scss'>

.delay {
  white-space: nowrap;
}
</style>
